export const environment = {
  production: false,
  apiBaseUrl: 'https://staging-api.morichalai.com/api',
  wsUrl: 'wss://staging-api.morichalai.com/ws',
};
